<template>
  <div class="app-container">
    <td>
      <img class :src=" coverUrl?  coverUrl : defaultCoverUrl" style="width:100%;display:block" />
    </td>
    <!-- <img class="banner" src="../../assets/images/banner.png" /> -->
    <div>
      <div class="news-detail">
        <div class="title">标杆医院签到</div>
        <div class="content">请您配合完成下面问卷并签到</div>
      </div>
      <van-cell-group v-for="(item, index) in questions" :key="index" class="cell-group">
        <div class="question"><span>{{index + 1}}.</span><span v-html="item.question.replace(/\n|\r\n/g, '<br>')"></span>
        <span v-if="item.type === 'RADIO'">(单选)</span>
        <span v-if="item.type === 'CHECKBOX'">(多选)</span>
        </div>
        <van-radio-group v-if="item.type === 'RADIO'" v-model="item.answer">
          <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
            <van-radio :name="option.seq">{{option.seq}}<strong>.</strong>&nbsp;{{ option.value }}</van-radio>
            <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
            <van-field v-if="option.value.indexOf('原因是')>-1" v-model="item.reason" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
            <van-field v-if="option.value.indexOf('工具为')>-1" v-model="item.tools" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
          </div>
        </van-radio-group>
        <van-checkbox-group v-if="item.type === 'CHECKBOX'" v-model="item.answer">
          <div v-for="(option, index) in JSON.parse(item.options)" :key="index">
            <van-checkbox shape="square" :name="option.seq">{{option.seq}}<strong>.</strong>&nbsp;{{ option.value }}</van-checkbox>
            <van-field v-if="option.value === '其他'" v-model="item.otherAnswer" placeholder="请输入内容" value="" maxlength=100 style="background-color: #f7f7f7"/>
          </div>
        </van-checkbox-group>
        <van-field v-if="item.type === 'TEXT'" rows="3" autosize type="textarea" v-model="item.answer" value=""/>
      </van-cell-group>
    </div>

    <div style="margin-top:20px;text-align:center;background:#fff">
      <van-button  @click="handleSubmit()" block class="button" color="#8259E1">签到并提交问卷</van-button>
    </div>
  </div>
</template>
<script>
import API from '@/api/common';
import wx from 'weixin-js-sdk'
export default {
  name: "exam",
  data() {
    return {
      coverUrl: '',
      defaultCoverUrl: require('../../assets/images/top.jpg'),
      name: '',
      openid: this.$route.query.openid,
      signId: '',
      hospitalId: this.$route.query.hospitalId,
      examId: this.$route.query.examId,
      questions: [],
      remark: ''
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.wxInstance();
      console.log('openid:' + this.openid)
      console.log('hospitalId:' + this.hospitalId)
      console.log('examId:' + this.examId)
      this.findExam(this.examId)
      this.getHospital(this.hospitalId)

    },
    getHospital(hospitalId) {
      API.getHospital(hospitalId).then(result => {
        this.coverUrl = result.data.coverUrl
        this.name = result.data.name
        document.title = result.data.name
        this.remark = result.data.remark
      })
    },
    wxInstance(){
      let params = {id: this.hospitalId}

      let title = '会前调研';
      API.getHospitalSignature(params).then(res => {
        wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: ['updateAppMessageShareData']
        });
        wx.ready(function () {
          var shareData = {
            title: title,
            desc: res.data.name,
            link: res.data.url,
            imgUrl: res.data.imgUrl,
            success: function () {
            }
          };
          wx.updateAppMessageShareData(shareData);
        });
      });
    },
    findExam(examId) {
      API.findExam(examId).then(result => {
        API.getCustomerInfo(this.openid).then(result1 => {
          console.info(result1)
          let customerInfo = result1.data
          this.questions = result.data.questionList
          this.questions.forEach( item => {
            if (item.type == 'RADIO') {
              item.answer = ''
            } else if (item.type == 'CHECKBOX') {
              item.answer = []
            } else if (item.type == 'TEXT' && item.question ==='专家姓名') {
              item.answer = customerInfo.tbName
            } else if (item.type == 'TEXT' && item.question ==='专家医院') {
              item.answer = customerInfo.hosName
            } else if (item.type == 'TEXT' && item.question ==='专家科室') {
              item.answer = customerInfo.department
            }
          })
        })
      })
    },
    valid() {
      let valid = true
      this.questions.forEach( item => {
        if (item.type == 'RADIO' && !item.answer) {
          valid = false
        } else if (item.type == 'CHECKBOX' && !item.answer.length > 0) {
          valid = false
        } else if (item.type == 'TEXT' && !item.answer) {
          valid = false
        }
      })
      return valid
    },
    handleSubmit() {
      if (this.valid()) {
        const openid = this.openid
        const hospitalId = this.hospitalId
        const examId = this.examId
        let questionList = []
        let params = {openid: openid,hospitalId: hospitalId}
        this.questions.forEach( item => {
          let question = { stockId: item.stockId, answer: item.answer.toString(), otherAnswer: item.otherAnswer || item.reason || item.tools }
          questionList.push(question)
        })
        API.createHospitalSign2(params).then((data) => {
          API.saveHospitalResult({ hospitalId: hospitalId, examId: examId,  openid: openid, quesList: questionList, signId: data.data.id }).then(data => {
            if (data.success) {
              this.$router.push({
                name: 'submitHospitalSuccess',
                query: { openid: openid, hospitalId: hospitalId, examId: examId, }
              });
            } else {
              this.$message.error(data.message)
            }
          })
        })
      } else {
        this.$message.error('还有问题未填写')
      }
    }
  }
}
</script>
<style lang='less' scoped>
.app-container{
  .banner {
    width: 100%;
    height: auto;
  }
  /deep/textarea{
    border:1px solid #ccc;
  }
  .button {
    width: 90%;
    margin: 25px auto;
    border-radius: 6px;
  }
  /deep/.van-cell-group{
    .question{
      font-size: 14px;
      padding: 5px 0;
    }
    .van-radio{
      margin:8px 0;
      font-size: 14px;
    }
    .van-checkbox__label{
      margin:8px;
      font-size: 14px;
    }
    margin:10px 20px;
    padding: 10px;
    border-radius: 5px;
    color: #646566;
  }
  .news-detail {
    height: 100%;
    margin-top: 20px;
    padding-bottom: 10px;
    overflow: auto;
    box-sizing: border-box;
    color: #646566;
    .title {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      text-align: center;
    }
    .examType {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
    }
    .content {
      margin: 5px 10px;
      font-size: 15px;
      color: #b1b1b1;
      text-align: center;
    }
  }
}

</style>
<style lang="less">
.content {
  .van-field__label {
    margin-left: 6px;
  }

  .van-icon__image {
    width: 18px;
    height: 18px;
  }
  .van-radio__label {
    color: #646566;
  }
}
</style>
